<template>
  <div class="content">
    <div class="table-page-operator-wrapper action-btn" >
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:sopMpCapacityLoad:exportType']">导出明细</a-button>
    </div>
    <a-spin :spinning="isLoading">
      <ls-api-table
        class="table"
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        rowKey="id"
        :scroll="{ fixScreen: true, x: 1300 }"
      >
        <template slot="month" slot-scope="{ record }">
          <span>{{ record.monthStart + '~' + record.monthEnd }}</span>
        </template>
        <template slot="updateTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="createTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="versionCode" slot-scope="{ record }">
          <a @click="handleGoVersion(record)" class="ml10">{{ record.versionCode }}</a>
        </template>
        <!-- 月份 -->
        <template slot="month" slot-scope="{ record, column }">
          <span v-if="!isEdit || currentId !== record.id">{{ (record[column.dataIndex]?record[column.dataIndex]:'0')+(column.pTitle.includes('产能负荷')?'%':'') }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.id"
            v-model="record[column.dataIndex]"
            size="small"
          />
          <!-- <a-button @click="(handlerTestClick(record, column))"> 测试</a-button> -->
        </template>
        <!-- 操作 -->
        <span slot="operation" slot-scope="{ record, $index }">
          <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record, $index)">编辑</a>
          <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDelete(typeList, record)">删除</a>
          <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
          <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
        </span>
      </ls-api-table>
    </a-spin>
    <import-data
      ref="importData"
      :url="url"
      :sopDfcBasicDataId="queryParams.monthPlanId"
      @handle-success="handleOk"
    />
  </div>
</template>

  <script>
import {
  apiScpSopFcInitialDeliveryRatio,
  apiDelScpSopFcInitialDeliveryRatio
} from '@/api/scp/shipmentForecast/shipmentForecastSetting'
import { generateLsTableResData } from '@/utils/util.js'
import ImportData from './ImportData'
import { ApiSopMpCapacityTypeList } from '@/api/scp/month-plan/month-plan.js'

export default {
  components: {
    ImportData
    },
  props: {
    id: {
      type: String,
      default: '1' // 设置默认值为'Hello from child'
    }
  },
  data () {
    const id = this.id
    return {
      isLoading: false,
      url: '/scp/scpSopFcInitialDeliveryRatio/import',
      isEdit: false,
      tableList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(ApiSopMpCapacityTypeList, true),
        pageCurrent: true
      },
      columns: [],
      columnsServe: [],
      // 表格字段
      columnsNative: [
        {
          title: '工艺大类',
          dataIndex: 'productBroadCategory',
          width: 180,
          align: 'center'
        },
        {
          title: '内外部',
          dataIndex: 'scpSupplierCategory',
          width: 120,
          align: 'center'
        }
      ],
      queryParams: {
        monthPlanId: id
      }
    }
  },
  methods: {
    handlerTestClick (record, column) {
      // debugger
    },
      /** 下载模板操作 */
      handleTemplate () {
      this.download('scp/scpSopFcInitialDeliveryRatio/download', {
        sopDfcBasicDataId: this.queryParams.monthPlanId
      }, `期初发货比例模版_${new Date().getTime()}.xlsx`)
    },
        // 接口请求成功后回调
        successCallBack (myDataSource) {
          // debugger
        },
        /** 导出按钮操作 */
   handleExport () {
      this.download('scp/sopMpCapacityLoad/exportType', {
        ...this.queryParams
      }, `月度计划-产能负荷列表-类型_${new Date().getTime()}.xlsx`)
    },
   // 新增/修改框事件
     handleOk () {
        // this.onSearch()
      },
    handleDelete (tableList, record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          const ids = []
          self.columnsServe.forEach((column) => {
            console.log(column.indexKey)
            const id = record[column.indexKey].id
            ids.push(id)
          })
          apiDelScpSopFcInitialDeliveryRatio(ids).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑-保存
    handleSave (record) {
      const recordCopy = JSON.parse(JSON.stringify(record))
      apiScpSopFcInitialDeliveryRatio(recordCopy).then((response) => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    getTableInfo (id) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      ApiSopMpCapacityTypeList(id).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.data.rows
          // this.tableList.forEach((obj, index) => {
          //   obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
          // })
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.data.title
          this.columnsServe = response.data.title
          // 生成新的对象数组，并为每个对象添加name属
          const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              children: title.children.map((childrenTitle) => {
                return {
                          title: childrenTitle.indexName,
                          dataIndex: childrenTitle.indexKey,
                          scopedSlots: { customRender: 'month' },
                          width: 120,
                          pTitle: title.indexName,
                          myTitle: childrenTitle.indexName,
                          align: 'center'
                        }
              })
            }
          })
          const dynamicColumn = this.setNewColumn('scpSupplierCategory', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.$refs.dataTable.myPagination.total = response.data.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.data.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.data.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
       this.$refs.dataTable.searchParams = this.queryParams;
      // this.$refs.dataTable.getData();
      this.$refs.dataTable.myPagination.current = 1
      this.getTableInfo({ monthPlanId: this.id, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
    },
    /**
     * 在table 某个列的字段后增加列
     * key：列的字段名称
     * columnList 列表的列
     * insertColumnList 插入的新列
     *  */
    setNewColumn (key, columnList, insertColumnList) {
      const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
      const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
      if (index !== -1) {
        newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
      }
      return newArray
    },
    // 编辑
    handleEdit (record, index) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    }
  },
  created () {
    // this.getTableInfo()
  },
  mounted () {
    this.columns = this.columnsNative
    this.onSearch()
  }
}
</script>

<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
}
.action-btn {
  display: flex;
  padding: 8px;
}
.table {
  flex: 1;
}
</style>
